import { z } from "zod";

/**
 * Level Schema - ระดับความยาก
 */
export const LevelSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  order: z.number().int().nullable(),
  status: z.enum(["active", "inactive"]),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type LevelDTO = z.infer<typeof LevelSchema>;

/**
 * Create Level Schema
 */
export const CreateLevelSchema = z.object({
  name: z.string().min(1, "ຊື່ຕ້ອງບໍ່ວ່າງ"),
  description: z.string().nullable().optional(),
  order: z.number().int().nullable().optional(),
  status: z.enum(["active", "inactive"]).default("active"),
});
export type CreateLevelDTO = z.infer<typeof CreateLevelSchema>;

/**
 * Update Level Schema
 */
export const UpdateLevelSchema = z.object({
  name: z.string().min(1, "ຊື່ຕ້ອງບໍ່ວ່າງ").optional(),
  description: z.string().nullable().optional(),
  order: z.number().int().nullable().optional(),
  status: z.enum(["active", "inactive"]).optional(),
});
export type UpdateLevelDTO = z.infer<typeof UpdateLevelSchema>;

/**
 * Reorder Levels Schema
 */
export const ReorderLevelsSchema = z.object({
  levelIds: z.array(z.string()).min(1, "ຕ້ອງມີຢ່າງໜ້ອຍ 1 ລະດັບ"),
});
export type ReorderLevelsDTO = z.infer<typeof ReorderLevelsSchema>;
